import { render, staticRenderFns } from "./EditTaxes.vue?vue&type=template&id=a52e8096"
import script from "./EditTaxes.vue?vue&type=script&lang=js"
export * from "./EditTaxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports